import { ChevronDown } from "lucide-react";
import type { ToolId } from "../../data/tools";
import { TOOL_SEO } from "../../data/toolSeo";

export function ToolSeoSection({ id }: { id: ToolId }) {
  const seo = TOOL_SEO[id];
  return (
    <section className="mt-6 space-y-4" data-testid="tool-seo-section">
      <article className="rounded-[20px] border-[3px] border-[#F2D9B8] bg-white p-4 text-[#3b1800]">
        <h2 className="font-comic text-xl uppercase text-[#FF5D1F] md:text-2xl" data-testid="tool-seo-heading">{seo.heading}</h2>
        {seo.intro.map((p) => <p key={p} className="mt-2 text-sm leading-relaxed md:text-base">{p}</p>)}
        <h3 className="mt-4 font-comic text-base uppercase">Great for</h3>
        <ul className="mt-1 grid gap-1 text-sm sm:grid-cols-2">
          {seo.uses.map((u) => <li key={u} className="before:mr-2 before:text-[#FF5D1F] before:content-['★']">{u}</li>)}
        </ul>
      </article>
      <div className="rounded-[20px] border-[3px] border-[#F2D9B8] bg-white p-4" data-testid="tool-faq">
        <h2 className="font-comic text-xl uppercase text-[#3b1800]">FAQ</h2>
        {seo.faqs.map((f, i) => (
          <details key={f.q} className="group border-b border-[#F2D9B8] py-2 last:border-0" data-testid={`tool-faq-item-${i}`}>
            <summary className="flex cursor-pointer list-none items-center justify-between gap-2 font-bold text-[#3b1800]">
              <h3 className="text-sm md:text-base">{f.q}</h3>
              <ChevronDown className="h-4 w-4 shrink-0 transition-transform group-open:rotate-180" />
            </summary>
            <p className="mt-1 text-sm text-[#6b3a12]">{f.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
